const defaultConfig = {
  productPricing: {
    strategy: 'compound-discount'
  }
};
const clientConfigs = {
  default: defaultConfig,
  ataco: defaultConfig,
  donator: {
    ...defaultConfig,
    productPricing: {
      ...defaultConfig.productPricing,
      strategy: 'price-inquiry'
    }
  }
};
export const getClientId = () => {
  try {
    if (typeof process !== 'undefined' && process.env) {
      return (process.env.REACT_APP_CLIENT || process.env.CLIENT || 'default').toLowerCase();
    }
  } catch (e) {
    // Browser builds may not expose process.
  }
  return 'default';
};
export const getClientConfig = () => clientConfigs[getClientId()] || defaultConfig;
export const getClientConfigValue = function (path) {
  let defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  const value = path.split('.').reduce((currentValue, key) => currentValue && typeof currentValue === 'object' && key in currentValue ? currentValue[key] : undefined, getClientConfig());
  return value === undefined ? defaultValue : value;
};